// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  playerId: __t.string().name("player_id"),
  ruleset: __t.string(),
  culture: __t.string(),
  displayName: __t.string().name("display_name"),
  meleeWeapon: __t.string().name("melee_weapon"),
  shield: __t.string(),
  armor: __t.string(),
  rangedWeapon: __t.string().name("ranged_weapon"),
  mount: __t.string(),
  training: __t.string(),
  weaponTrainingRank: __t.u32().name("weapon_training_rank"),
  shieldTrainingRank: __t.u32().name("shield_training_rank"),
  formationTrainingRank: __t.u32().name("formation_training_rank"),
  enduranceTrainingRank: __t.u32().name("endurance_training_rank"),
  skirmishingTrainingRank: __t.u32().name("skirmishing_training_rank"),
  horsemanshipTrainingRank: __t.u32().name("horsemanship_training_rank"),
  fieldcraftTrainingRank: __t.u32().name("fieldcraft_training_rank"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
